import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/work", label: "Work" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <header className="sticky top-0 z-40 border-b border-border bg-background/85 backdrop-blur-xl">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4 sm:px-10">
        <Link
          to="/"
          data-testid="nav-logo"
          className="flex items-baseline gap-2"
          onClick={() => setOpen(false)}
        >
          <span className="text-lg font-bold tracking-tight">John Doe</span>
          <span className="h-1.5 w-1.5 bg-[#FF4D00]" />
        </Link>

        <nav className="hidden items-center gap-9 sm:flex">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `link-underline text-sm transition-colors hover:text-[#FF4D00] ${
                  isActive ? "text-[#FF4D00]" : "text-foreground/70"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/dashboard"
            data-testid="nav-link-dashboard"
            className={`font-mono-label transition-colors hover:text-foreground ${
              pathname === "/dashboard" ? "text-foreground" : ""
            }`}
          >
            Dashboard
          </Link>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="sm:hidden"
          aria-label="Toggle menu"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <nav className="border-t border-border bg-background sm:hidden" data-testid="nav-mobile-panel">
          {[...links, { to: "/dashboard", label: "Dashboard" }].map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              onClick={() => setOpen(false)}
              className="block border-b border-border px-6 py-4 text-sm"
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
      )}
    </header>
  );
};
